<ng-container>
    <mat-form-field class="width-100">
        <mat-label>{{field?.label}}</mat-label>
        <input matInput [formControl]="control" [matDatepicker]="picker" [min]="getMin(field?.max)"
            [max]="getMax(field?.min)" [required]="required"/>

        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-hint *ngIf="field?.description">{{ field.description }}</mat-hint>
        <mat-datepicker #picker startView="multi-year"
            (monthSelected)="setMonthAndYear($event, picker)"></mat-datepicker>
    </mat-form-field>
</ng-container>